<template>
  <div v-if="displayShowcaseContainer">
    <div class="col-md-12">
      <div class="panel profile-panel profile-showcases">
        <template v-if="tournaments.length">
          <h3 class="text-center">Tournaments & Events</h3>
          <div id="tournaments">
            <draggable
                @end="arrangeTournaments" v-model="tournaments"
                :options="{animation: 150, disabled: roles.is_public, forceFallback: true}"
            >
              <div
                  v-for="(tournament, index) in tournaments"
                  :class="{'tw-cursor-move' : ! roles.is_public}"
              >
                <div class="tw-flex tw-justify-between tw-mb-6 tw-border-b tw-border-grey-light">
                  <div class="tw-flex tw-flex-col tw-mb-6">
                    <h4 v-text="tournament.tournament.name"></h4>
                    <div><span v-text="tournament.tournament.location"></span> - <span
                        v-text="tournament.tournament.start_date"
                    ></span> to <span
                        v-text="tournament.tournament.end_date"
                    ></span></div>
                  </div>
                  <div class="tw-flex tw-justify-end tw-items-center">
                    <delete-button
                        :item-id="tournament.id"
                        type="tournaments"
                        :message="`Are you sure you want to delete ${tournament.tournament.name} from your profile?`"

                    />

                    <edit-button
                        modal-target="editTournament"
                        :modal="{title: 'Edit Tournament & Event', index}"
                    />
                  </div>
                </div>
                <div class="row tw-py-2">
                  <div class="col-md-3">Finish:</div>
                  <div class="col-md-3">{{ tournament.tournament.finish }}</div>
                </div>
                <div class="row tw-py-2">
                  <div class="col-md-3">Score:</div>
                  <div class="col-md-3">{{ tournament.tournament.score }}</div>
                </div>
                <div class="row tw-py-2">
                  <div class="col-md-3">Field:</div>
                  <div class="col-md-3">{{ tournament.tournament.field_size }}</div>
                </div>
                <div class="row tw-py-2 tw-mb-6">
                  <div class="col-md-3">Yardage/Par:</div>
                  <div class="col-md-3">{{ tournament.tournament.yardage }}</div>
                </div>
                <div class="row tw-py-2 tw-mb-4">
                  <div class="col-md-3">{{ tournament.tournament.comments }}</div>
                </div>
                <swiper
                    v-if="tournament.videos.length"
                    ref="slider"
                    :options="carouselOptions"
                    class="swiper"
                >
                  <swiper-slide
                      v-for="video in tournament.videos"
                      :key="video.id"
                  >
                    <highlight-video
                        :video="video"
                        :key="randomInteger(video.id)"
                        :no-actions="true"
                        @preview="preview"
                    />
                  </swiper-slide>
                </swiper>
              </div>
            </draggable>
          </div>
          <add-button
              modal-target="editTournament" v-if="roles.is_owner"
              :modal="{title: 'Add Tournament & Event'}"
          ></add-button>
        </template>
        <empty-state
            v-else
            title="Tournament & Events"
            description="Show off your best tournament finishes and list other events you've participated in that are relevant."
            :button="{caption: 'Add Tournament & Events'}"
            :modal="{title: 'Add a Tournament'}"
            modalTarget="editTournament"
        />
      </div>
    </div>
    <video-preview
        :visible="previewModalVisible"
        :video="previewVideo"
        @closed="clearPreview"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import EditButton from '../VisualElements/EditButton';
import DeleteButton from '../VisualElements/DeleteButton';
import AddButton from '../VisualElements/AddButton';
import draggable from 'vuedraggable';
import HighlightVideo from '../HighlightVideos/HighlightVideo';
import VideoPreview from '../VisualElements/VideoPreview';
import EmptyState from '../EmptyState';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import randomInterger from '../../mixins/randomInteger';

export default {
  name: 'GolfAthletics',
  mixins: [randomInterger],
  data() {
    return {
      previewModalVisible: false,
      previewVideo: null,
      carouselOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 7,
          },
          920: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 7,
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 5,
          },
          400: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 2,
          },
        },
      },
    };
  },
  components: {
    EditButton,
    DeleteButton,
    AddButton,
    draggable,
    HighlightVideo,
    VideoPreview,
    EmptyState,
    Swiper,
    SwiperSlide,
  },
  computed: {
    ...mapGetters({
      roles: 'player-profile/roles',
      tournamentsData: 'player-profile/tournaments',
      profileData: 'player-profile/profile',
    }),
    tournaments: {
      get() {
        return this.tournamentsData;
      },
      set(data) {
        this.setData({
          type: 'tournaments',
          data,
        });
      },
    },
    displayShowcaseContainer() {
      if (this.roles.is_public) {
        if (!this.tournaments.length > 0) {
          return false;
        }
      }

      return true;
    },
    slider() {
      return this.$refs.slider[0].$swiper;
    },
  },
  methods: {
    ...mapActions({
      updateOrder: 'player-profile/updateOrder',
    }),
    ...mapMutations({
      setData: 'player-profile/setData',
    }),
    arrangeTournaments() {
      let orders = this.profileData.tournaments.map(tournament => {
        return { id: tournament.id };
      });

      this.updateOrder({
        type: 'tournament',
        orders,
      });
    },
    clearPreview() {
      this.previewVideo = null;
    },
    preview(video) {
      this.previewVideo = video;
      this.previewModalVisible = true;
    },
    prevSlide() {
      this.slider.slidePrev();
    },
    nextSlide() {
      this.slider.slideNext();
    },
  },
};
</script>

<style lang="scss">
$padding: -20px;

.showcase-videos {
  position: relative;

  &__navigation {
    top: 50%;
    font-size: 36px;
    color: #5b9bd1;
    cursor: pointer;
    transform: translateY(-50%);

    &_next {
      position: absolute;
      right: $padding;
    }

    &_prev {
      position: absolute;
      left: $padding;
    }
  }
}

.swiper {

  &-slide {
    display: flex;
    justify-content: center;
  }

  &-pagination {
    position: relative;
    bottom: 0 !important;
  }
}
</style>
